import { forwardRef, useId, useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import styles from './Input.module.css'

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  type?: 'text' | 'email' | 'password'
  label?: string
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ type = 'text', label, error, className, id: idProp, ...props }, ref) => {
    const autoId = useId()
    const id = idProp ?? autoId
    const [visible, setVisible] = useState(false)
    const isPassword = type === 'password'

    return (
      <div className={[styles.field, className].filter(Boolean).join(' ')}>
        {label && (
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
        )}
        <div className={styles.wrap}>
          <input
            ref={ref}
            id={id}
            type={isPassword ? (visible ? 'text' : 'password') : type}
            className={[styles.input, error ? styles.hasError : ''].filter(Boolean).join(' ')}
            {...props}
          />
          {isPassword && (
            <button
              type="button"
              className={styles.toggle}
              onClick={() => setVisible((v) => !v)}
              tabIndex={-1}
              aria-label={visible ? 'Passwort verbergen' : 'Passwort anzeigen'}
            >
              {visible ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          )}
        </div>
        {error && <span className={styles.errortxt}>{error}</span>}
      </div>
    )
  }
)
Input.displayName = 'Input'
